import React, { useEffect, useState } from 'react';
import { AUTH_DISABLED, getLoginUrl, exchangeCodeForTokens, getStoredTokens, storeTokens, getUser, logout } from './auth';

export const AuthContext = React.createContext(null);

function AuthGate({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (AUTH_DISABLED) {
      setUser({ username: 'dev-user', email: 'dev@amazon.com', givenName: 'Dev', familyName: 'User' });
      setLoading(false);
      return;
    }

    // Check for auth code in URL (callback from Cognito)
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code) {
      // Exchange code for tokens
      exchangeCodeForTokens(code)
        .then(tokens => {
          storeTokens(tokens);
          // Clean URL
          window.history.replaceState({}, '', window.location.pathname);
          setUser(getUser());
          setLoading(false);
        })
        .catch(() => {
          window.location.href = getLoginUrl();
        });
      return;
    }

    // Check for existing session
    const tokens = getStoredTokens();
    if (tokens) {
      setUser(getUser());
      setLoading(false);
      return;
    }

    // No session, redirect to login
    window.location.href = getLoginUrl();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'system-ui' }}>
        <div style={{ textAlign: 'center' }}>
          <h2>JAR JAR</h2>
          <p>Authenticating...</p>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthGate;
